import React from "react";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Fab from "@mui/material/Fab";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import OrderDetail from "./OrderDetail";

const menuHeader = {
  icon: <AssignmentIcon sx={{ color: "white" }} fontSize="small" />,
  name: "Order",
};

const menu = [
  { link: "order", name: "Order" },
  { link: "packing-slip", name: "Packing Slip" },
  { link: "invoice", name: "Invoice" },
];

export default function Order() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        width: "100%",
      }}
    >
      <IconMenu menuHeader={menuHeader} menu={menu} />

      <Paper
        sx={{
          width: "100%",
          marginLeft: "20px",
          padding: "20px",
        }}
      >
        <Routes>
          <Route
            path="/"
            element={<OrderDetail/>}
          />
          <Route
            path="/products"
            element={
              <>
                <Fab
                  color="secondary"
                  sx={{ position: "absolute", bottom: 35, right: 35 }}
                >
                  <EditIcon />
                </Fab>
                <Fab
                  color="primary"
                  sx={{ position: "absolute", bottom: 35, right: 100 }}
                >
                  <PrintIcon />
                </Fab>
                <Fab
                  color="warning"
                  sx={{ position: "absolute", bottom: 35, right: 165 }}
                >
                  <SaveAltIcon />
                </Fab>
              </>
            }
          />
        </Routes>
      </Paper>
    </Box>
  );
}
